<template>
  <div id="info" style="padding-top: 50px;">
      <div style="text-align:right;" class="top-right">
        <van-button @click="backFn()" round type="info" class="btn">返 回 牌 桌</van-button> 
        <van-button @click="skipFn()" round type="info" class="btn">申 请 称 号</van-button> 
      </div>

      <div class="user">
          <img v-if="info.wxAvater" :src="info.wxAvater" style="border-radius: 100%"/>
          <img v-else src="@/assets/avatar.png" style="border-radius: 100%"/>
          <van-button v-if="info.vipType" size="mini" type="info" class="paybtn leftPos">VIP</van-button> 
          <div>
             <div>
                 HI,{{ info.wxName ? info.wxName : "塔罗师！"}}
             </div>
             <div class="time">
                 <template v-if="info.expiredIn">
                  到期:{{info.expiredIn.split(' ')[0]}} 
                 </template>
                <van-button v-if="info.expiredIn" size="mini" type="info" class="paybtn" @click="skipPay()">续时</van-button> 
                <van-button v-else size="mini" type="info" class="paybtn" @click="skipPay()">付费</van-button> 
             </div>
          </div>
      </div>
      <div class="tabBox">
          <van-tabs @click="onClick"  type="card"  v-model="activeName">
            <van-tab title="第一步：主页面设置" name="one">
              <div class="box">
                  <div class="title">
                      <van-icon name="play" />设置昵称：<span style="color:red">*</span>
                  </div>
                  <div class="titleInfo">
                      <van-field v-model="form.userName" />
                  </div>
                  <div class="title">
                      <van-icon name="play" />设置手机号：<span style="color:red">*</span>
                  </div>
                  <div class="titleInfo">
                      <van-field v-model="form.phone" />
                  </div>
                  <div class="title">
                      <van-icon name="play" />上传头像：</span>
                  </div>
                  <div class="titleInfo">
                      <van-uploader max-count="1" :preview-full-image="false" v-model="fileList" :after-read="afterRead" style="vertical-align:bottom"/>
                      <span style="font-size: 10px; vertical-align:bottom;display:inline-block;padding-bottom: 8px;">（头像请使用100x100，1M容量以内的图片）</span>
                  </div>
                  <div class="title">
                      <van-icon name="play" />佩戴认证徽章：
                      <span style="font-size: 10px;">（单选）</span>
                  </div>

                  <div class="titleInfo" v-if="info0.length">
                      <div @click="prevFn(1)" class="prevStyle">
                          <van-icon name="arrow-left" />
                      </div>
                      <div @click="nextFn(1)" class="nextStyle">
                          <van-icon name="arrow" />
                      </div>
                      <van-swipe class="swipe1" :show-indicators="false" :loop="false" :width="60" ref="swipe1">

                        <van-swipe-item v-for="item in info0" @click="check1(item)" :class="form.badge == item.id ? 'activeTag' : 'noActiveTag'">
                          <img :src="getUrl(item.url)"/>
                          <div>{{item.name}}</div>
                        </van-swipe-item>
                      </van-swipe>
                  </div>
                  <div v-else class="titleInfo" >
                    <span style="font-size: 10px;display:block;text-align:center;">您暂无可佩戴徽章，请去页面右上角申请认证！</span>
                  </div>
                  <div class="title">
                      <van-icon name="play" />佩戴认证称号：
                      <span style="font-size: 10px;">（可多选）</span>
                  </div>
                  <div class="titleInfo">
                      <van-checkbox-group v-model="checklist" direction="horizontal">
                        <van-checkbox v-for="item in info1" :name="item.id">{{item.name}}</van-checkbox>
                        <!--
                        <van-checkbox name="b">复选框 b</van-checkbox>
                        -->
                      </van-checkbox-group> 
                      <span v-if="!info1.length" style="font-size: 10px;display:block;text-align:center;">您暂无可佩戴称号，请去页面右上角申请认证！</span>
                  </div>
                  <div class="title">
                      <van-icon name="play" />设置初始桌布：
                  </div>
                  <div class="titleInfo">
                      <div @click="prevFn(2)" class="prevStyle">
                          <van-icon name="arrow-left" />
                      </div>
                      <div @click="nextFn(2)" class="nextStyle">
                          <van-icon name="arrow" />
                      </div>
                      <van-radio-group v-model="form.skin">
                        <van-swipe class="swipe1 swipe2" :show-indicators="false" :loop="false" :width="100" ref="swipe2">
                          <van-swipe-item v-for="item in info2">
                            <img :src="getUrl(item.littlePicUrl)"/>
                            <div><van-radio :name="item.id">{{item.name}}</van-radio></div>
                          </van-swipe-item>
                          <!--
                          <van-swipe-item>
                            <img src="@/assets/vip2.png"/>
                            <div><van-radio name="2">单选框 1</van-radio></div>
                          </van-swipe-item>
                          <van-swipe-item>
                            <img src="@/assets/vip3.png"/>
                            <div><van-radio name="3">单选框 1</van-radio></div>
                          </van-swipe-item>
                          <van-swipe-item>
                            <img src="@/assets/vip4.png"/>
                            <div><van-radio name="4">单选框 1</van-radio></div>
                          </van-swipe-item>
                          <van-swipe-item>
                            <img src="@/assets/vip5.png"/>
                            <div><van-radio name="5">单选框 1</van-radio></div>
                          </van-swipe-item>
                          <van-swipe-item>
                            <img src="@/assets/vip6.png"/>
                            <div><van-radio name="6">单选框 1</van-radio></div>
                          </van-swipe-item>
                          -->
                        </van-swipe>
                      </van-radio-group>
                  </div>
                  <div class="title">
                      <van-icon name="play" />设置初始牌背：
                  </div>
                  <div class="titleInfo">
                      <div @click="prevFn(3)" class="prevStyle prevStyle3">
                          <van-icon name="arrow-left" />
                      </div>
                      <div @click="nextFn(3)" class="nextStyle nextStyle3">
                          <van-icon name="arrow" />
                      </div>
                      <van-radio-group v-model="form.card">
                        <van-swipe class="swipe1 swipe2 swipe3" :show-indicators="false" :loop="false" :width="100" ref="swipe3">
                          <van-swipe-item v-for="item in info3">
                            <img :src="getUrl(item.littlePicUrl)"/>
                            <div><van-radio :name="item.id">{{item.name}}</van-radio></div>
                          </van-swipe-item>
                          <!--
                          <van-swipe-item>
                            <img src="@/assets/vip1.png"/>
                            <div><van-radio name="1">单选框 1</van-radio></div>
                          </van-swipe-item>
                          <van-swipe-item>
                            <img src="@/assets/vip2.png"/>
                            <div><van-radio name="2">单选框 1</van-radio></div>
                          </van-swipe-item>
                          <van-swipe-item>
                            <img src="@/assets/vip3.png"/>
                            <div><van-radio name="3">单选框 1</van-radio></div>
                          </van-swipe-item>
                          <van-swipe-item>
                            <img src="@/assets/vip4.png"/>
                            <div><van-radio name="4">单选框 1</van-radio></div>
                          </van-swipe-item>
                          <van-swipe-item>
                            <img src="@/assets/vip5.png"/>
                            <div><van-radio name="5">单选框 1</van-radio></div>
                          </van-swipe-item>
                          <van-swipe-item>
                            <img src="@/assets/vip6.png"/>
                            <div><van-radio name="6">单选框 1</van-radio></div>
                          </van-swipe-item>
                          -->
                        </van-swipe>
                      </van-radio-group>
                  </div>
              </div>
              <div class="footer">
                  <div class="prebtn2" @click="skipView()">本页预览</div> 
                  <div class="card" @click="skipTab()">
                      <div>
                          <van-icon name="down" />
                      </div>
                      编辑个人名片
                  </div>
                  <div class="link" @click="submitFn()">跳过名片设置页，直接生成牌桌链接</div>
              </div>
            </van-tab>
            <van-tab title="第二步：个人名片设置" name="two">
              <div class="box">
                  <div class="title">
                      <van-icon name="play" />设置身份：<span style="color:red">*</span>
                  </div>
                  <div class="titleInfo">
                      <van-field v-model="form.identity" />
                  </div>
                  <div class="title">
                      <van-icon name="play" />上传展示照片：</span>
                  </div>
                  <div class="titleInfo">
                      <van-uploader max-count="1" :preview-full-image="false" v-model="fileList2" :after-read="afterRead2" style="vertical-align:bottom"/>
                      <span style="font-size: 10px; vertical-align:bottom;display:inline-block;padding-bottom: 8px;">（请上传尺寸3:4的图片，超过部分将自动裁剪）</span>
                  </div>
                  <div class="title">
                      <van-icon name="play" />编辑正文：
                  </div>
                  <div class="titleInfo">
                      <van-radio-group v-model="form.subhead1Show" direction="horizontal">
                        <van-radio name="1">展示副标题1</van-radio>
                        <van-radio name="0">不展示副标题1</van-radio>
                      </van-radio-group> 
                      <div style="margin: 10px 0;">
                        <van-field class="yearinput" placeholder="1" v-model="form.subhead1" type="digit" />  年实战经验
                      </div>
                      <van-radio-group v-model="form.subhead2Show" direction="horizontal">
                        <van-radio name="1">展示副标题2</van-radio>
                        <van-radio name="0">不展示副标题2</van-radio>
                      </van-radio-group> 
                      <div style="margin: 10px 0;">
                        <van-field class="yearinput" placeholder="1000" v-model="form.subhead2" type="digit" />  + 案例
                      </div>
                      <div style="margin-top:15px;">添加更多介绍</div>
                      <div style="margin: 10px 0;">
                        <van-field class="yeartext" type="textarea" rows="5" placeholder="请输入介绍" v-model="form.description" />
                      </div>
                  </div>
                  <div class="title">
                      <van-icon name="play" />展示个人二维码：</span>
                  </div>
                  <div class="titleInfo">
                      <van-uploader max-count="1" :preview-full-image="false" v-model="fileList3" :after-read="afterRead3" style="vertical-align:bottom"/>
                      <span style="font-size: 10px; vertical-align:bottom;display:inline-block;padding-bottom: 8px;">（请上传正方形尺寸二维码图片，否则无法展示）</span>
                  </div>
                  <div class="title">
                      <van-icon name="play" />编辑二维码推广语：
                      <span style="font-size: 10px; vertical-align:bottom;display:inline-block;">（限定15字内）</span>
                  </div>
                  <div class="titleInfo">
                      <div style="margin: 10px 0;">
                        <van-field class="yeartext" type="textarea" rows="8" placeholder="请输入推广语" v-model="form.extendContent" />
                      </div>
                  </div>
              </div>
              <div class="footer">
                  <div class="prebtn2" @click="skipView()">本页预览</div> 
                  <div class="card" @click="linkFn()">
                      <div>
                          <van-icon name="down" />
                      </div>
                      生成牌桌链接
                  </div>
              </div>
            </van-tab>
          </van-tabs>
      </div>
  </div>
</template>

<script>
import { Dialog, Toast } from 'vant';
export default {
  data() {
    return {
        name: '',
        info: {wxAvater: ''},
        info0: [],
        info1: [],
        info2: {},
        info3: {},
        activeName: 'one',
        upload:{
            avatar: '',
        },
        form: {
          badge: '',
          skin: '',
          card: '',
          title: '',
          subhead1Show: '1',
          subhead2Show: '1',
        },
        fileList: [],
        fileList2: [],
        fileList3: [],
        url: 'https://metaser.cn:12700/',
        checklist: [],
        radio1: '1',
        radio2: '1',
        title1: '1',
        title2: '1',
        input1: '',
        input2: '',
        input3: '',
        input4: '',
        swipe1: [{name:'1'},{name:'2'},{name:'3'}],
        swipecheck1: '1'
    };
  },
  methods: {
    backFn(){
        let that = this;
        let params = {};
        this.$post('api/divination/user/createInvocationUrl', params)
        .then((res) => {
            this.message = res.data;
            console.log(res.data)
            if(res.data){
              window.location.href = res.data;
            }else{
              Toast.loading({
                duration: 3000,
                message: '您还没有建立自己的塔罗牌桌面!',
                forbidClick: true,
              });
            }
        }) 
    },
    skipTab(){
      this.activeName = 'two';
    },
    submitFn(){
        if(!this.isPhone()){
            this.$notify({ type: 'danger', message: '请输入正确的手机号！' });
            return;
        }
        if(this.fileList.length){
            this.form.avatar = this.fileList[0].id;
            this.form.avatarUrl = this.fileList[0].url;
        }
        if(this.fileList2.length){
            this.form.showPhoto = this.fileList2[0].id;
            this.form.showPhotoUrl = this.fileList2[0].url;
        }
        if(this.fileList3.length){
            this.form.qrCode = this.fileList3[0].id;
            this.form.qrCodeUrl = this.fileList3[0].url;
        }
        if(this.checklist.length){
            this.form.title = this.checklist.join(',')
        }else{
            this.form.title = ''
        }
        if(!this.info.expiredIn){
          Toast.loading({
            duration: 2000,
            message: '请先购买会员',
            forbidClick: true,
          });
          this.$router.push({path:'/pay'})
          return false;
          //if(this.form.skin != this.info2[0].id){
          //    Toast.loading({
          //      duration: 2000,
          //      message: '请先购买会员',
          //      forbidClick: true,
          //    });
          //    this.$router.push({path:'/pay'})
          //    return false;
          //}
          //if(this.form.card != this.info3[0].id){
          //    Toast.loading({
          //      duration: 2000,
          //      message: '请先购买会员',
          //      forbidClick: true,
          //    });
          //    this.$router.push({path:'/pay'})
          //    return false;
          //}
        }

        this.form.id = this.info.id;
        console.log(this.form);

        console.log(this.form);

        let that = this;
        let openid = window.sessionStorage.getItem('openid');
        let params = this.form
        this.$post('api/divination/user/save', params)
        .then((res) => {
          if(res.code == '0'){
            this.$router.push({path:'/link'})
          }else{
            this.$notify({ type: 'danger', message: res.msg });
          }
        }) 
    },
    getUrl(url){
      return this.url + url;
    },
    getImage(id, type){
        let that = this;
        let params = {
          "id": id,
        }
        let img = '' 
        this.$fetch('api/divination/file/downLoadPicture', params)
        .then((res) => {
            console.log(res);
            if(type == 1){
              this.fileList[0] = {url: (this.url + res), id: id}
            }else if(type == 2){
              this.fileList2[0] = {url: (this.url + res), id: id}
            }else{
              this.fileList3[0] = {url: (this.url + res), id: id}
            }
        }) 
    },
    afterRead(file){
        let that = this;
        const formData = new FormData();
        formData.append('file', file.file);
        Toast.loading({
          duration: 100000,
          message: '上传中...',
          forbidClick: true,
        });
        this.$postUp('api/divination/file/uploadFile', formData)
        .then((response) => {
            Toast.clear();
            that.getImage(response.data[0],1);
        }) 
    },
    afterRead2(file){
        let that = this;
        const formData = new FormData();
        formData.append('file', file.file);
        Toast.loading({
          duration: 100000,
          message: '上传中...',
          forbidClick: true,
        });
        this.$postUp('api/divination/file/uploadFile', formData)
        .then((response) => {
            Toast.clear();
            that.getImage(response.data[0],2);
        }) 
    },
    afterRead3(file){
        let that = this;
        const formData = new FormData();
        formData.append('file', file.file);
        Toast.loading({
          duration: 100000,
          message: '上传中...',
          forbidClick: true,
        });
        this.$postUp('api/divination/file/uploadFile', formData)
        .then((response) => {
            Toast.clear();
            that.getImage(response.data[0],3);
        }) 
    },
    skipFn(){
      this.$router.push({path:'/apply'})
    },
    skipPay(){
      this.$router.push({path:'/pay'})
    },
    linkFn(){
      this.submitFn();
      //this.$router.push({path:'/link'})
    },
    isPhone() {
       let phoneNumber = this.form.phone;
       return /^1\d{10}$/.test(phoneNumber);
    },
    skipView(){
      if(!this.isPhone()){
          this.$notify({ type: 'danger', message: '请输入正确的手机号！' });
          return;
      }

      if(this.fileList.length){
          this.form.avatar = this.fileList[0].id;
          this.form.avatarUrl = this.fileList[0].url;
      }
      if(this.fileList2.length){
          this.form.showPhoto = this.fileList2[0].id;
          this.form.showPhotoUrl = this.fileList2[0].url;
      }
      if(this.fileList3.length){
          this.form.qrCode = this.fileList3[0].id;
          this.form.qrCodeUrl = this.fileList3[0].url;
      }
      if(this.checklist.length){
          this.form.title = this.checklist.join(',')
      }
      this.form.id = this.info.id;
      console.log(this.form);
      let that = this;
      let openid = window.sessionStorage.getItem('openid');
      let params = this.form
      this.$post('api/divination/user/save', params)
      .then((res) => {
        //window.sessionStorage.setItem('savelink',res);
        //this.$router.push({path:'/link'})
          if(res.code == '0'){
            this.$router.push({path:'/view', query:{name: this.activeName}})
          }else{
            this.$notify({ type: 'danger', message: res.msg });
          }
      }) 





      //this.info2.map(item => {
      //    if(item.id == this.form.skin){
      //      this.form.skinUrl = item.url
      //    }
      //})
      //this.info3.map(item => {
      //    if(item.id == this.form.card){
      //      this.form.cardUrl = item.url
      //    }
      //})
      //this.$router.push({path:'/view', query: { b: this.form.skinUrl , c: this.form.cardUrl}})
    },
    prevFn(type){
      this.$refs['swipe' + type].prev();
    },
    nextFn(type){
      this.$refs['swipe' + type].next();
    },
    check1(item){
        if(this.form.badge == item.id){
          this.form.badge = '';
        }else{
          this.form.badge = item.id;
        }
    },
    onClick(name, title) {
    },
    getInfo(){
        let that = this;
        let openid = window.sessionStorage.getItem('openid');
        let params = {
          "unionId": openid,
        }
        this.$post('api/divination/user/get', params)
        .then((res) => {

            if(res.data.expiredIn){
              let time  = res.data.expiredIn.split(' '); 
              if(new Date().getTime() > new Date((time[0]+'T'+time[1])).getTime()){
                  res.data.expiredIn = '';
              }
            }
            that.info = res.data;
            window.sessionStorage.setItem("expiredIn",that.info.expiredIn);
            that.form = JSON.parse(JSON.stringify(res.data));
            
            if(that.form.avatar){
                this.fileList[0]={
                  id: that.form.avatar,
                  url: that.url + that.form.avatarUrl,
                };
            }
            if(that.form.avatar){
                this.fileList2[0]={
                  id: that.form.showPhoto,
                  url: that.url + that.form.showPhotoUrl,
                };
            }
            if(that.form.showPhoto){
                this.fileList3[0]={
                  id: that.form.qrCode,
                  url: that.url + that.form.qrCodeUrl,
                };
            }
            if(that.form.title){
                let arr = that.form.title.split(',')
                let arr2 = [];
                arr.map(item => {
                  arr2.push(Number(item)) 
                })
                this.checklist = arr2;
            }
            this.form.subhead1Show = String(this.form.subhead1Show);
            this.form.subhead2Show = String(this.form.subhead2Show);


        }) 
    },
    getMsg(){
        let that = this;
        let params = {
          "types": [0,1,2,3],
        }
        this.$post('api/divination/constant/get', params)
        .then((res) => {
            let arr0 = [];
            let arr1 = [];
            let arr2 = [];
            let arr3 = [];
            res.data.map(item => {
              console.log(item);
                if(item.type == 0){
                    arr0.push(item);
                }else if(item.type == 1){
                    arr1.push(item);
                }else if(item.type == 2){
                    arr2.push(item);
                }else if(item.type == 3){
                    arr3.push(item);
                }
            })
            //this.info0 = arr0;
            //this.info1 = arr1;
            this.info2 = arr2;
            this.info3 = arr3;
            this.form.badge = arr0[0].id
            this.form.skin = arr2[0].id;
            this.form.card = arr3[0].id;
        })
        this.$post('api/divination/user-badge/get', params)
        .then((res) => {
            let arr0 = res.data;
            this.info0 = (arr0 ? arr0 : []);
            this.form.badge = arr0[0].id
        })
    },
    getCH(){
      let that = this;
      let params = {};
      this.$post('api/divination/user-title/get', params)
      .then((res) => {
          console.log(res.data)
          this.info1 = res.data;
      }) 
    },
    init(){
        this.getInfo();
        this.getCH();
        // 0、徽章 1、称号 2、皮肤 3、牌面 
        this.getMsg();
    }
  },
  created (){
    this.init();
  }
};
</script>
<style scope>
#info .btn{
  height: 25px;
  line-height: 25px;
  background-color: rgba(96,25,133);
  border: rgba(96,25,133);
  margin-right: 25px;
  font-size: 12px;
}
#info .user{
  font-size: 18px;
  position: relative;
  width: 80%;
  margin: 0 auto;
  text-align:left;
  margin-bottom: 30px;
}
#info .user img{
  display:inline-block;
  width: 50px;
  vertical-align: bottom;
}
#info .user > div{
  display:inline-block;
  padding-left: 15px;
  vertical-align: bottom;
  width: calc(100% - 75px);
}
#info .user .time{
  font-size: 12px;
}
#info .paybtn{
  height: 12px;
  line-height: 12px;
  font-size: 10px;
  border-radius: 5px;
  background-color: rgba(96,25,133);
  border: rgba(96,25,133);
  vertical-align:middle;
}
#info .leftPos{
  position:absolute;
  left: 30px;
  bottom: 0;
}
#info .van-tabs__nav--card{
  border: 0!important;
}
#info .van-tab{
  background-color: rgba(194,194,194) !important;
  color: #fff !important;
  border: 0!important;
  font-size: 12px;
  border-radius: 15px 15px 0 0;
  padding: 0 20px !important;
} 
#info .van-tab--active{
  background-color: rgba(96,25,133) !important;
}
#info .box{
  background: #fff;
  border-radius: 20px;
  border: 1px solid #eee;
  padding: 20px;
  text-align: left;
}
#info .tabBox{
  width:calc(100% - 20px);
  margin: 0 auto;
}
#info .van-tabs__nav--card{
  overflow: hidden;
}
#info .van-icon-play{
  font-size: 16px;
  margin-right: 5px;
  color: rgba(96,25,133) !important;
}
#info .title{
  font-size: 16px;
}

#info .titleInfo .van-radio__icon{
  font-size: 13px;
}
#info .titleInfo{
  margin: 10px 0;
  margin-bottom: 20px;
  font-size: 13px;
  position:relative;
}
#info .titleInfo .van-field{
  border: 1px solid #eee;
  height: 40px;
  line-height: 40px;
  border-radius: 20px;
}
#info .van-checkbox__icon{
  display: inline-block;
}
#info .van-checkbox-group > div{
  display: block;
  width: 100%;
}
#info .van-checkbox__icon--round .van-icon{
  font-size: 12px;
}
#info .swipe1{
  height: 60px;
  width: calc(100% - 60px);
  margin: 20px auto;
}
#info .swipe1 img{
    width: 40px;
}
#info .nextStyle, .prevStyle{
  position:absolute;
  top: -24px;
  bottom:0;
  margin: auto 0;
  line-height: 100px;
  font-size: 20px;
}
#info .prevStyle{
  left: 0;
}
#info .nextStyle{
  right: 0;
}
#info .van-swipe-item{
  text-align:center;
  font-size: 10px;
}

#info .swipe2{
    height: 120px;
}
#info .nextStyle2, #info .prevStyle2{
  line-height: 100px;
}
#info .swipe2 img{
    width: 64px;
    height: 100px;
}
#info .swipe2 .van-radio__icon{
    font-size: 12px;
}
#info .swipe2 .van-radio__label{
    margin-left:5px;
}
#info .swipe2 .van-radio{
    display:block;
}
#info .swipe2 .van-radio .van-radio__icon{
    display:inline-block;
}


#info .swipe3{
    height: 130px;
}
#info .nextStyle3,#info  .prevStyle3{
  line-height: 100px;
}
#info .swipe3 img{
    width: 64px;
    height: 100px;
}
#info .footer{
    margin-top: 25px;
    padding-bottom: 30px;
}
#info .prebtn2{
    background-color: rgba(96, 25, 133);
    border-radius: 15px;
    height: 18px;
    line-height: 18px;
    width: 60px;
    font-size: 12px !important;
    color:#fff;
    margin: 0 auto;
}
#info .footer .link{
    color: rgba(96, 25, 133);
    font-size: 10px;
}
#info .footer .card{
    background-color: rgba(96, 25, 133);
    border-radius: 25px;
    height: 30px;
    line-height: 30px;
    width: 180px;
    font-size: 16px;
    color:#fff;
    margin: 10px auto;
    position: relative;
    text-align:center;
}
#info .footer .card > div{
    display: inline-block;
    position: absolute;
    left:0;
    width: 26px;
    height: 26px;
    left:2px;
    top:2px;
    border-radius: 100%;
    background: #fff;
    color: rgba(96, 25, 133);
    transform: rotate(270deg);
}
#info .van-field__control{
  height: 25px;
}
#info .yearinput {
  display:inline-block;
  width: 50px;
  height: 25px !important;
  line-height: 25px !important;
  padding:0;
  vertical-align: bottom;
}
#info .yearinput input{
  text-align:center;
}
#info .yeartext{
  height: auto !important;
  line-height: 20px;
}
#info .yeartext textarea{
  line-height: 20px;
}
#info .activeTag img{
  border: 3px solid rgba(96,25,133);
}
#info .noActiveTag img{
  border: 2px solid transparent;
}
.top-right{
  right: 0;
  top:0;
  z-index: 10;
  position: absolute;
}
.top-right button{
  margin-top: 10px;
  display: block;
}
</style>

